/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/318-arrow-down-right2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M2.293 3.707L10.586 12H7a1 1 0 000 2h6a1.002 1.002 0 001-1h.001V7a1 1 0 00-2 0v3.586L3.708 2.293a.997.997 0 00-1.414 0 .999.999 0 000 1.414z"/>'
  }
})
